module.exports = __webpack_public_path__ + "static/media/kakao.75de4c02.svg";